// extracted by mini-css-extract-plugin
export default {"contactsInfo":"ContactsInfo_contactsInfo__E0gT3"};